/* eslint-disable import/no-anonymous-default-export */
export default {
    title: 'dark',

    colors: {
        primary: '#161616',
        secundary: '#1c1c1c',

        background: '#2b2b2b',
        text: '#fff',
        details: "#0c0c0c"
    },
}